<script setup lang="ts">
import { Statuses } from '@/@types/order'
import { Input } from '@/components/ui/input'
import { Select, SelectContent, SelectItem, SelectSeparator, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useForm } from '@inertiajs/vue3'
import { inject, watch } from 'vue'

import { useUrlSearchParams } from '@vueuse/core'

defineProps<{
    statuses: Statuses
}>()

const params = inject('params', useUrlSearchParams())

const form = useForm({
    id: String(params.id || ''),
    status: String(params.status || ''),
})

watch(
    () => form.data(),
    () => {
        params.status = form.status
        params.id = form.id
        params.current_page = '1'
        params.old_page = '1'

        form.get('/orders', {
            preserveScroll: true,
            only: ['orders', 'old_orders', 'current_pagination', 'old_pagination', 'status', 'id', 'current_workshop_titles'],
            preserveState: true,
        })
    },
)
</script>

<template>
    <form class="grid items-center gap-3 lg:grid-cols-4">
        <Input type="number" v-model="form.id" :placeholder="$t('Order number')" class="w-full rounded-md border border-slate-300 px-3 py-2" />
        <Select v-model="form.status">
            <SelectTrigger class="w-full">
                <SelectValue :placeholder="$t('Order status')" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem :value="null">
                    {{ $t('Order status') }}
                </SelectItem>
                <SelectSeparator />
                <SelectItem v-for="status in statuses" :value="status" :key="status">
                    {{ $t(status) }}
                </SelectItem>
            </SelectContent>
        </Select>
    </form>
</template>
